import { FeatureFlags } from '@logz-pkg/enums';
import { sessionStateService } from '@logz-pkg/frontend-services';

export class FeatureFlagStateService {
  isFeatureEnabled = (featureName: keyof typeof FeatureFlags): boolean => {
    const session = sessionStateService.session.get();

    return session?.featureFlags?.includes(FeatureFlags[featureName]) ?? false;
  };
}

export const featureFlagStateService = new FeatureFlagStateService();
